export const CHANGE_SECURITY_QUESTION_REQUEST =
  "CHANGE_SECURITY_QUESTION_REQUESET";
export const CHANGE_SECURITY_QUESTION_RECEIVE =
  "CHANGE_SECURITY_QUESTION_RECEIVE";
export const CHANGE_SECURITY_QUESTION_ERROR = "CHANGE_SECURITY_QUESTION_ERROR";
export const UPDATE_SECURITY_QUESTIION_MESSAGE =
  "UPDATE_SECURITY_QUESTIION_MESSAGE";
